module.exports = __webpack_public_path__ + "img/serve@2x.02b32d66.png";